<template>
  <v-dialog v-model="show" class="modal" persistent max-width="739px" scrollable>
    <v-card class="container">
      <h1 class="dialog-title">{{ userMessageDialog.title }}</h1>
      <p class="dialog-description">{{ userMessageDialog.description }}</p>
      <div class="btn-container">
        <a :target="userMessageDialog.target" :href="userMessageDialog.btnLink" style="width: 100%">
          <main-button :text="userMessageDialog.btnText" color="#333" style="width: 100%" />
        </a>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'user-message-dialog',
  props: {
    userMessageDialog: {
      type: Object,
      default: () => {},
    },
    show: Boolean,
  },
  methods: {
    closeDialog() {
      this.$v.$reset()
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.container {
  display: flex;
  width: 389px;
  padding: 32px 32px 40px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
}

.dialog-description {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.dialog-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
}

.btn-container {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
</style>
